export default {
  new_tag: 'Uusi',
  groups: {
    dashboards: 'Hallintapaneelit',
    online_shop: 'Verkkokauppa',
    home: 'Koti',
    marketing: 'Markkinointi',
    reservations: 'Varaukset',
    website: 'Verkkosivusto',
    orders_portal: 'Avaa tilausportaali',
    roi: 'ROI',
    google_ads: 'Google Ads',
    mobile_app: 'Mobiilisovellus',
    phone_answering: 'Puhelinvastaus',
    pricing: 'Hinnoittelu',
    team: 'Tiimi',
    data_deletion_requests: 'Tietojenpoistopyynnöt',
    partner: 'Kumppani',
  },
  get_started: {
    title: 'Aloitus',
  },
  onboarding: {
    title: 'Käyttöönotto',
  },
  new_restaurant: {
    title: 'Uusi ravintola',
  },
  gift_cards: {
    title: 'Lahjakortit',
  },
  top_items: {
    title: 'Suosituimmat tuotteet',
  },
  dashboards: {
    title: 'Hallintapaneelit',
    children: {
      general: 'Yleiset',
      restaurant_details: 'Ravintolan tiedot',
      external_delivery: 'Ulkoinen toimitus',
      overview: 'Yleiskatsaus',
      orders: 'Tilaukset lähteen mukaan',
      google: 'Google',
      customers: 'Asiakkaat',
    },
  },
  customer_base: {
    title: 'Asiakaskunta',
  },
  new_company: {
    title: 'Uusi ravintola',
  },
  agent_ops_queue: {
    title: 'AI-ehdotukset',
  },
  external_delivery_support: {
    title: 'Ulkoisen toimituksen tuki',
  },
  payment_gateways: {
    title: 'Maksuyhdyskäytävät',
  },
  developers: {
    title: 'Kehittäjät',
  },
  feature_flags: {
    title: 'Ominaisuuslipukkeet',
  },
  platform_agent_log: {
    title: 'Amigo-loki',
  },
  test_restaurants: {
    title: 'Testiravintolat',
  },
  partners: {
    title: 'Kumppanit',
  },
  partner: {
    children: {
      account: 'Tili',
      branding: 'Brändäys',
      payment_gateway: 'Maksuyhdyskäytävä',
      billing: 'Laskutus',
      tax_currency: 'Verot ja valuutta',
      service_fee_calculator: 'Palvelumaksulaskuri',
      processing_fees: 'Käsittelymaksut',
    },
  },
  going_live: {
    title: 'Julkaisu',
    children: {
      setup_package_fulfillments: 'Logsta-toimitukset',
      polygraphy: 'Painotuotteet',
    },
  },
  franchises: {
    title: 'Brändit',
  },
  setup_package_fulfillments: {
    title: 'Käyttöönottopaketit',
  },
  website: {
    title: 'Verkkosivusto',
    children: {
      storefront: 'Storefront',
      studio: 'Studio (V1)',
      studio_v2: 'Studio (V2)',
    },
  },
  reservations: {
    title: 'Varaus',
    children: {
      overview: 'Yleiskatsaus',
      booking_availability: 'Varauskapasiteetti',
      settings: 'Asetukset',
      general: 'Yleiset',
      storefront: 'Storefront',
    },
  },
  subscriptions: {
    title: 'Tilaukset',
    children: {
      subscriptions: 'Tilaukset',
      products: 'Tuotteet',
    },
  },
  sales: {
    title: 'Myynti',
    children: {
      orders: 'Tilaukset',
      receipts: 'Asiakaskuitit',
      external_deliveries: 'Ulkoiset toimitukset',
    },
  },
  billing: {
    title: 'Raportit',
    children: {
      monthly_statements: 'Kuukausikatsaukset',
      payouts: 'Maksut',
      invoices: 'Laskut',
      subscription: 'Tilaus',
      sales_summary: 'Myyntiyhteenveto',
      internal_invoice_items: 'Sisäiset laskurivit',
      income_reports: 'Tuloraportit',
      tax_reports: 'Veroraportit',
    },
  },
  master_menu: {
    title: 'Brändin synkronointi',
  },
  menu: {
    title: 'Ruokalista',
    children: {
      master_overview: 'Brändit',
      manage_menus: 'Hallinnoi ruokalistoja',
      modifiers: 'Lisukkeet',
      smart_pricing: 'Älykäs hinnoittelu',
      upsell_items: 'Lisämyyntituotteet',
      sold_out_items: 'Loppuunmyydyt tuotteet',
      import: 'Tuonti',
      edit_history: 'Muokkaushistoria',
    },
  },
  my_store: {
    title: 'Omat tiedot',
    children: {
      settings: 'Profiili',
      gallery: 'Galleria',
      business_information: 'Yritystiedot',
      documents: 'Omat asiakirjat',
      personal_information: 'Henkilötiedot',
      bank_info: 'Pankkitiedot',
      tax_info: 'Verotiedot',
      shipping_info: 'Toimitustiedot',
      google_profile: 'Google-profiili',
      seo: 'SEO',
      impressum: 'Yritystiedot',
      imprint: 'Yritystiedot',
      post_launch: 'Julkaisun jälkeen',
      tax_currency: 'Verot ja valuutta',
    },
  },
  opening_hours: {
    title: 'Aukioloajat ja sijainti',
    children: {
      opening_hours: 'Aukioloajat',
      location: 'Sijainti',
    },
  },
  order_settings: {
    title: 'Tilausasetukset',
    children: {
      takeout: 'Tilaustavat',
      missed_orders: 'Missatut tilaukset',
      order_layout: 'Tilausasettelu',
      payment_methods: 'Maksutavat',
      connect_paypal: 'Yhdistä PayPal',
      tips: 'Tipit',
      service_fee: 'Maksut',
      processing_fees: 'Käsittelymaksut',
      receipt: 'Kuitti',
      staff_credentials: 'Henkilökunnan tunnukset',
      integrations: 'Integraatiot',
      terminal: 'Maksupääte',
      invoices: 'Laskut',
    },
  },
  mobile_app: {
    title: 'Mobiilisovellus',
    children: {
      overview: 'Yleiskatsaus',
      updates: 'Päivitykset',
      intro_screen: 'Aloitusnäyttö',
    },
  },
  marketing: {
    children: {
      overview: 'Yleiskatsaus',
      followers: 'Seuraajat',
      email_messages: 'Sähköpostiviestit',
      push_notifications: 'Push-ilmoitukset',
      promo_codes: 'Alennuskoodit',
      offers: 'Tarjoukset',
      google_business: 'Google Business',
      google_review_program: 'Google-arvosteluohjelma',
      loyalty_program: 'Kanta-asiakasohjelma',
      polygraphy: 'Painotuotteet',
      tracking_links: 'Seurantalinkit',
      google_ads: 'Google Ads',
      website_analytics: 'Verkkosivuston analytiikka',
      featured_posts: 'Julkaisut mobiilisovelluksessa',
    },
  },
  loyalty_tablet: {
    title: 'Kanta-asiakastabletti',
    children: {
      dashboard: 'Kojelauta',
      settings: 'Asetukset',
      credentials: 'Tunnukset',
    },
  },
  contract: {
    title: 'Sopimus',
    children: {
      agreement: 'Sopimus',
      template: 'Malli',
    },
  },
  team: {
    children: {
      managers: 'Johtajat',
      reports: 'Raportit',
    },
  },
};
